var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPetFriendly = function SvgPetFriendly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.008 20-7.496-7.423a4.996 4.996 0 1 1 7.496-6.561 4.998 4.998 0 0 1 8.99 2.86",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.5 14.502v0a3.001 3.001 0 0 1 3.002 3.001v0a1 1 0 0 1-1 1h-4.003a1 1 0 0 1-1-1v0a3.001 3.001 0 0 1 3.001-3.001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.25a.25.25 0 1 0 .001.5.25.25 0 0 0-.002-.5M20.502 12.25a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M17.5 11.25a.25.25 0 1 0 .003.5.25.25 0 0 0-.002-.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPetFriendly;